export const EMPLOYEE_TITLES = {
  VPOfGrowth: 'VP Of Growth',
  PricingAnalyst: 'Pricing Lead',
  Concierge: 'Your Concierge',
  HomeownerGrowth: 'Homeowner Advisor',
  ResidentGrowth: 'Leasing Advisor',
  SalesOperation: 'Onboarding Ops',
  ImprovementsAssessor: 'Onboarding Ops',
  Pro: 'Belong Pro',
  HeadOfOperations: 'Head Of Operations',
  HeadOfExperience: 'Head Of Experience',
  SalesDevelopmentRepresentative: 'Homeowner Associate',
  HomeImprovementsSpecialist: 'Home Quality Specialist',
  PricingTeam: 'Pricing Team',
  HomeOccupancySpecialist: 'Occupancy Specialist',
  BelongTeamMember: 'Belong Team Member',
};

export const LastUpdated = {
  last_updated_general: 'Last Updated {date}',
};
